import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';
import { cn } from '@playbooks/ui/lib/utils';

export const ItemAvatar = ({ thumbnail, title, className = '' }) => {
	// Theme
	const rootClassName = cn('flex-start', className);

	// Render
	return (
		<Avatar className={rootClassName}>
			<AvatarImage size='xs' src={thumbnail} alt={title} />
			<AvatarContent>
				<AvatarDescription className='text-sm leading-none'>{title}</AvatarDescription>
			</AvatarContent>
		</Avatar>
	);
};
